import {Market} from './market';
import {MarketLevel} from './market-level';
import {MarketLevelRef} from './market-level-ref';
import {BaseModelMicroService} from './base-model-micro-service';

export class MarketRef extends BaseModelMicroService {
    name: string;
    code: string;

    marketLevel: MarketLevelRef;
    parents: MarketRef[] = [];

    constructor(pMarket?: Market) {
        super();
        if (pMarket) {
            this.id = pMarket.Id;
            this.name = pMarket.MarketName;
            this.code = pMarket.MarketCode;

            this.prepareMarketLevel(pMarket.MarketLevel);
            if (pMarket.ParentMarketList && pMarket.ParentMarketList.length > 0) {
                this.prepareParents(pMarket.ParentMarketList);
            }

        }
    }

    prepareMarketLevel(pMarketLevel: MarketLevel): void {
        this.marketLevel = new MarketLevelRef(pMarketLevel);
    }

    prepareParents(pParentMarkets?: Market[]): void {
        this.parents = pParentMarkets.map(pParent => new MarketRef(pParent));
    }
}
